var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19.5A1.5 1.5 0 0 1 22 18h3a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 1-1.5-1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 4A3.5 3.5 0 0 0 .5 7.5v17A3.5 3.5 0 0 0 4 28h25a3.5 3.5 0 0 0 3.5-3.5v-17A3.5 3.5 0 0 0 29 4zm25.5 6V7.5A.5.5 0 0 0 29 7H4a.5.5 0 0 0-.5.5V10zm-26 3h26v11.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5z",
    clipRule: "evenodd"
  })));
};
export default SvgCreditCard;